import { useEffect, useEffectEvent } from 'react';
import { ErrorLike } from '@apollo/client';
import { skipToken, useQuery } from '@apollo/client/react';

import { PageDrawer } from 'common/components/PageDrawer';
import { IPageDrawerProps } from 'common/components/PageDrawer/PageDrawer';
import { NotFound } from 'common/components/NotFound';
import { Loader } from 'common/components/Loader';
import { useApolloError } from 'common/hooks/useApolloError';
import { useRouteQuery } from 'route/hooks/useRouteQuery';
import { BudgetRequestDocument } from 'graphql/types';

import { BudgetRequestDetail } from './BudgetRequestDetail';

interface IProps extends IPageDrawerProps {
    budgetRequestId?: string;
    onClose?: () => void;
}

export const BudgetRequestDetailDrawer = ({
    budgetRequestId,
    onClose,
    ...other
}: IProps) => {
    const routeQuery = useRouteQuery();
    const { showApolloError } = useApolloError();

    const requestId = budgetRequestId || routeQuery.get('id') || '';

    const { data, loading, error } = useQuery(
        BudgetRequestDocument,
        requestId ? { variables: { id: requestId } } : skipToken
    );

    const onError = useEffectEvent((error: ErrorLike) => {
        showApolloError(error);
    });

    useEffect(() => {
        if (error) {
            onError(error);
        }
    }, [error]);

    const budgetRequest = data?.budgetRequest;
    const budgetRequestNotFound = !loading && !budgetRequest;

    return (
        <PageDrawer onClose={onClose} {...other}>
            {loading && <Loader />}

            {budgetRequestNotFound && <NotFound />}

            {!!budgetRequest && !loading && (
                <BudgetRequestDetail budgetRequest={budgetRequest} />
            )}
        </PageDrawer>
    );
};
